module.exports = __webpack_public_path__ + "static/media/dashboard-grey-arrow.f9d4c52e.png";